var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',_vm._b({attrs:{"options":_vm.options,"name":_vm.$trans(_vm.row.name),"label":"label","reduce":o => o.value},on:{"input":v => _vm.$emit('input', v)}},'input-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }